'use client';
import { createComponent } from "../internals/utils/index.js";
var NavbarBrand = createComponent({
  name: 'NavbarBrand',
  componentAs: 'a',
  componentClassPrefix: 'navbar-brand'
});
export default NavbarBrand;